import { render, staticRenderFns } from "./twoFac.vue?vue&type=template&id=abf6bfee&"
import script from "./twoFac.vue?vue&type=script&lang=js&"
export * from "./twoFac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports